import { pleaseImplement } from '@ui-system/utils';

import { InnerShadowType } from './types';

const InnerShadow: InnerShadowType =
  pleaseImplement<InnerShadowType>('InnerShadow');

export default InnerShadow;
